import LocaleService from 'modules/Localization';
import Broker from 'modules/TradingChart/components/TradingView/utils/providers/brokerProvider';
import { ThemeName } from './components/TradingView/sources/charting_library.min';
import { OrderType } from './components/TradingView/sources/charting_library';

export enum ServerIntervals {
  ONE_MINUTE = '1',
  ONE_DAY = '1d',
}

export const MAP_TV_INTERVAL_TO_SERVER_INTERVAL: {
  [key in string]: string;
} = {
  [ServerIntervals.ONE_MINUTE]: 'I1',
  [ServerIntervals.ONE_DAY]: '1d',
};

// NOTE: 5 hours 30 minutes in milliseconds
export const KOLKATA_TIMEZONE_DIFFERENCE_IN_MILLISECONDS = 19800000;
export const DIFFERENCE_FOR_TIMESTAMP_IN_MILLISECONDS = 72000000 * 2;

interface IBrokerData {
  instance: Broker | null;
}

export const broker: IBrokerData = {
  instance: null,
};

export const durations = [
  {
    name: 'Day',
    value: 'DAY',
    default: true,
    supportedOrderTypes: [
      OrderType.Market,
      OrderType.Limit,
      OrderType.Stop,
      OrderType.StopLimit,
    ],
  },
  {
    name: 'IOC',
    value: 'IOC',
    supportedOrderTypes: [
      OrderType.Market,
      OrderType.Limit,
      OrderType.Stop,
      OrderType.StopLimit,
    ],
  },
];

export const THEME_KEYS: { [key in ThemeKeys]: ThemeName } = {
  dark: 'dark',
  darkMobile: 'dark',
  light: 'light',
  lightMobile: 'light',
  mobikwik: 'light',
  auto: 'dark', // just added for placeholder
};

export const CloudStorage = LocaleService.translate('CLOUD_STORAGE');
export const LocalStorage = LocaleService.translate('LOCAL_STORAGE');
export const cloudStorageKeyPoints = [
  LocaleService.translate('CLOUD_STORAGE_KEY_POINT_1'),
  LocaleService.translate('CLOUD_STORAGE_KEY_POINT_2'),
  LocaleService.translate('CLOUD_STORAGE_KEY_POINT_3'),
];

export const INTERVAL_TYPE = {
  D: 'days',
  M: 'months',
  W: 'weeks',
  m: 'minutes',
  h: 'hours',
};

export const OptionChainModalMinWidth = 1060;

// Mapping indicator names to their respective input keys
export const INDICATOR_INPUT_KEY_MAP: Record<string, string[]> = {
  Ratio: ['symbol2'],
  Spread: ['symbol2'],
  'Correlation Coefficient': ['in_0'],
  'Correlation - Log': ['instrument', 'instrument2'],
  'Moving Average': ['symbol'],
  Volume: ['symbol'],
};

export const UPSTOX_LAYOUT_NAME = 'Upstox Layout';
